import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
export const switchDiv = "omponents__Switch__Switch_styles_ts-switchDiv-s1shuxv3";
export const disabledStyles = "omponents__Switch__Switch_styles_ts-disabledStyles-d1ea9vp2";
export const round = "omponents__Switch__Switch_styles_ts-round-r79wt77";

require("./Switch.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Switch.styles.ts");